import { memo, useMemo, type FC } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { getDataTestId } from '@/js/libs/utils/get-data-test-id/index.ts';

import { Title, Wrapper } from './styled.ts';

interface ItemProps {
  id: string;
  title: string;
  active: boolean;
  setActiveId: (id: string) => void;
  dataTestId: string | undefined;
}

export const Item: FC<ItemProps> = memo(function Item({ id, title, active, setActiveId, dataTestId }) {
  const testId = useMemo(() => getDataTestId(dataTestId, active ? 'active' : 'inactive'), [active, dataTestId]);

  const handleClick = useCallbackRef(() => {
    setActiveId(id);
  });

  return (
    <Wrapper $active={active} onClick={handleClick} data-testid={testId}>
      <Title>{title}</Title>
    </Wrapper>
  );
});
